import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OferecerEspacoNaVolta.css";

import {
  getStoredData,
  saveToGlobalState,
  clearAppState,
} from "../../utils/localStorage";
import { UseFinalizarCadastramentoMala } from "../../hooks/UseFinalizarCadastramentoMala/UseFinalizarCadastramentoMala";

const STORAGE_KEY = "oferecer_espaco_na_volta";

const OferecerEspacoNaVolta = () => {
  const navigate = useNavigate();
  const [espacoSelecionado, setEspacoSelecionado] = useState("");
  const { finalizarCadastramento, loading } = UseFinalizarCadastramentoMala();

  useEffect(() => {
    const data = getStoredData();
    if (data?.[STORAGE_KEY]) {
      setEspacoSelecionado(data[STORAGE_KEY]);
    }
  }, []);

  const handleChange = (value) => {
    setEspacoSelecionado(value);

    saveToGlobalState({
      [STORAGE_KEY]: value,
      tab_login: "VIAJANTE",
    });
  };

  const handleNext = async () => {
    if (!espacoSelecionado) return;

    try {
      const result = await finalizarCadastramento();

      const stored = getStoredData();
      const type = stored?.qual_meio_transporte;

      const routes = {
        aviao: "/aviao",
        onibus: "/onibus",
        trem: "/trem",
        carro: "/carro",
        moto: "/moto",
      };

      const route = routes[type];

      if (espacoSelecionado === "sim" && route) {
        clearAppState();

        saveToGlobalState({
          qual_meio_transporte: type,
          voltando_trajeto: "sim",
          tab_login: "VIAJANTE",
        });

        navigate(route);
        return;
      }

      clearAppState();
      saveToGlobalState({
        tab_login: "VIAJANTE",
      });
      navigate("/dashboard-traveler");
    } catch (err) {
      console.error(err);
    }
  };

  const handleBack = () => {
    navigate("/espaco-disponivel");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && espacoSelecionado && !loading) {
        e.preventDefault();
        handleNext();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [espacoSelecionado, loading]);

  return (
    <>
      <section className="espaco-oferecer-espaco-card">
        <div className="espaco-header" style={{ marginBottom: "20px" }}>
          <h2 className="espaco-title">Deseja Oferecer espaço na volta?</h2>
        </div>

        <div className="opcoes-wrap">
          <button
            type="button"
            className={`opcao-card ${espacoSelecionado === "sim" ? "ativo" : ""}`}
            onClick={() => handleChange("sim")}
          >
            <span className="opcao-titulo">Sim</span>
            <span className="opcao-subtitulo">Quero oferecer espaço</span>
          </button>

          <button
            type="button"
            className={`opcao-card ${espacoSelecionado === "nao" ? "ativo" : ""}`}
            onClick={() => handleChange("nao")}
          >
            <span className="opcao-titulo">Não</span>
            <span className="opcao-subtitulo">Não quero oferecer</span>
          </button>
        </div>

        <div className="espaco-actions space-around">
          <button type="button" className="btn-back" onClick={handleBack}>
            Voltar
          </button>

          <button
            type="button"
            className="btn-next"
            onClick={handleNext}
            disabled={!espacoSelecionado || loading}
          >
            {loading ? "Salvando..." : "Próximo"}
          </button>
        </div>
      </section>
    </>
  );
};

export default OferecerEspacoNaVolta;
